import { use, useEffect, useRef, useState } from "react";
import axios from "axios";
import "./OnboardingPending.css";
import { useNavigate } from "react-router-dom";
import { format, addDays } from 'date-fns';
import { onboardingEmployesPending } from "../../../services/onBoardingEmployeesService";

const OnboardingPending = () => {
  const [submitted, setSubmitted] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.userId;
  const effectRan = useRef(false);
  useEffect(() => {
    const fetchSubmitted = async () => {
      setLoading(true);
      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/documents-verification/status/INACTIVE`);
        const response = await onboardingEmployesPending();
        setSubmitted(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error("Failed to load approved applications", err);
        setSubmitted([]);
      } finally {
        setLoading(false);
      }
    };
    if (!effectRan.current) {
      fetchSubmitted();
    }
    return () => {
      effectRan.current = true;
    }

  }, []);

  const handleClick = (app) => {
    const applicationId = app.employeeUniqueId;
    if (!applicationId) {
      alert("Application ID is missing.");
      return;
    }
    navigate("/employeeJoiningForm", { state: { application: app, applicationId } });
  };

  // Current date and time
  const currentDateTime = format(new Date(), "dd-MM-yyyy, hh:mm a");

  return (
    <div>
      {loading ? (
        <div className="loading">Loading...</div>
      ) : submitted.length === 0 ? (
        <div className="empty-state">No approved applications found.</div>
      ) : (
        <div className="submitted-table">
          <div className="submitted-header">
            <div className="submitted-col">Full Name</div>
            <div className="submitted-col">Designation</div>
            <div className="submitted-col">Expected Report Date</div>
            <div className="submitted-col">Action</div>
          </div>
          {submitted.map((app) => {
            return (
              <div key={app.id} className="submitted-row">
                <div className="submitted-col">
                  {app.fullName || "N/A"}
                </div>
                <div className="submitted-col">
                  {app.designation || "N/A"}
                </div>
                <div className="submitted-col">{app.joiningDate}</div>
                <div className="submitted-col">
                  <button
                    className="submitted-view-button"
                    onClick={() => handleClick(app)}
                  >
                    Joining Form
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OnboardingPending;